import { Box, Text } from '@chakra-ui/react';

type Props = {
  isOwn: boolean;
  fileName?: string | null;
  fileSize?: number | null;
  formattedSize?: string;
  pdfUrl?: string;
  onOpen?: (url: string) => void;
};

export function PdfBubble({ isOwn, fileName, fileSize, formattedSize, pdfUrl, onOpen }: Props) {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2.5}
      px={2.5}
      py={2}
      borderRadius="10px"
      bg={isOwn ? 'blue.400' : 'gray.200'}
      _hover={{ bg: isOwn ? 'blue.300' : 'gray.300' }}
      minW="180px"
      maxW="260px"
      mb={1}
      cursor="pointer"
      onClick={(e) => {
        e.stopPropagation();
        if (pdfUrl) {
          onOpen?.(pdfUrl);
        }
      }}
    >
      <Box flexShrink={0} color="red.500">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect x="4" y="3" width="14" height="18" rx="2" ry="2" fill="currentColor" />
          <path d="M9 8h6M9 11h6M9 14h3" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      </Box>
      <Box minW={0} flex="1">
        <Text
          fontSize="xs"
          fontWeight="semibold"
          color={isOwn ? 'white' : 'gray.800'}
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          display="block"
        >
          {fileName ?? 'document.pdf'}
        </Text>
        <Text fontSize="10px" color={isOwn ? 'blue.100' : 'gray.500'}>
          {formattedSize ?? (fileSize != null ? `${fileSize} bytes` : 'PDF')}
        </Text>
      </Box>
    </Box>
  );
}

